<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="产品">
              <el-select v-model="searchParams.proId" clearable @change="chgPro" placeholder="请选择">
                <el-option v-for="item in productList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>

              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Sprint">
              <el-select v-model="searchParams.sprintId" @change="chgSprint" clearable
                v-show="sprintListData && sprintListData.length > 0" placeholder="请选择">
                <el-option v-for="itm in this.sprintListData" :key="itm.id" :label="itm.name" :value="itm.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3" v-show="selectTeam">
            <el-form-item label="人日:">
              {{ allPlaned ? allPlaned + ' / ' : '' }}
              {{ curSprint ? curSprint.allManDay * 8 : '' }} 工时
            </el-form-item>
          </el-col>
          <el-col :span="4" v-show="selectTeam">
            <el-form-item label="Team:">
              {{ selectTeam }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="operator">
      <el-button type="primary" size="mini" icon="el-icon-plus" v-show="searchParams.sprintId && searchParams.proId"
        @click="toSave()">添加执行</el-button>&nbsp;&nbsp;
      <span v-show="alreadyArrangedWH && completeWH">已完成工时:<el-tag type="danger" size="mini">
          {{ ((completeWH / alreadyArrangedWH) * 100).toFixed(1) }}% </el-tag>({{ completeWH }}/{{ alreadyArrangedWH }})
        /已分配工时:<el-tag type="danger" size="mini">{{ ((alreadyArrangedWH / availableWH) * 100).toFixed(1) }}%
        </el-tag>
        ({{ alreadyArrangedWH }}/{{ availableWH }})</span>
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table class="table" :data="listData" stripe border height="auto" @selection-change="selectionChange"
        v-loading="listLoading" row-key="id" lazy :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
        <el-table-column prop="name" label="代办名称"> </el-table-column>
        <el-table-column prop="problogName" label="产品代办">
          <template slot-scope="scope">
            {{
              scope.row.problogName
                ? scope.row.problogName
                : scope.row.surveyName
            }}
            <el-tag size="mini" v-if="scope.row.surveyName" type="danger">审视</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="tmName" width="90" label="成员/状态">
          <template slot-scope="props">
            {{ props.row.tmName }}
            <el-tag size="mini" type="info" v-if="!props.row.states || props.row.states === '未开始'">未开始</el-tag>
            <el-tag size="mini" v-else-if="props.row.states === '进行中'" type="warning">进行中</el-tag>
            <el-tag size="mini" v-else-if="props.row.states === '已完成'" type="success">已完成</el-tag>
            <el-tag size="mini" v-else-if="props.row.states === '已关闭'" type="danger">已关闭</el-tag>
            <el-tag size="mini" v-else-if="props.row.states === '已挂起'" type="danger">已挂起</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="surcnt" width="110" label="审视">
          <template slot-scope="scope">
            <span v-if="scope.row.surcnt">
              <el-tag title="点击查看" @click="showSur(scope.row.surcnt)" type="danger">
                {{ scope.row.lastsurtm }}
              </el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="hopegs" width="90" label="计划工时" title="完成工时/计划工时">
          <template slot-scope="scope">
            <div :title="'任务原始工时为:' + scope.row.hopegsOrg">
              {{ scope.row.wchours ? scope.row.wchours : 0 }}/
              <span :style="scope.row.hopegsOrg < scope.row.hopegs ? 'color:red' : 'color:black'">{{ scope.row.hopegsOrg
              }}
              </span>
            </div>
            <el-tag size="mini" v-if="scope.row.wchours" :type="scope.row.wchours / scope.row.hopegs == 1
              ? 'success'
              : 'warning'
              ">{{ ((100 * scope.row.wchours) / scope.row.hopegs).toFixed(0) }} %
            </el-tag>
          </template>
        </el-table-column>
        
        <el-table-column prop="hopegs" width="100" label="工时效率">
          <template slot-scope="scope">
            <div :title="scope.row.realgs +'小时做了'+ scope.row.wchours+'小时的任务'" >
            <div v-if="scope.row.realgs > 0">
               {{ scope.row.wchours }} / {{ scope.row.realgs ? scope.row.realgs : 0 }}
            </div>
            <el-tag size="mini"   v-if="scope.row.wchours && scope.row.wchours != 0" :type="scope.row.realgs / scope.row.wchours <= 1 ? 'success' : 'danger'
              ">{{ ((100 * scope.row.wchours) / scope.row.realgs).toFixed(0) }} %
            </el-tag>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="pbgntm" label="计划开始/完成" width="120">
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.pbgntm" type="success">
              {{ scope.row.pbgntm }}
            </el-tag>
            <el-tag size="mini" v-if="scope.row.pendtm" type="danger">
              {{ scope.row.pendtm }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="bgntm" label="实际开始/完成" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.bgntm">
              <el-tag size="mini" v-if="scope.row.bgntm" type="success">
                {{ scope.row.bgntm }}
              </el-tag>
              <el-tag size="mini" v-if="scope.row.endtm" type="danger">
                {{ scope.row.endtm }}
              </el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="devcnt" width="70" label="日志数">
          <template slot-scope="scope">
            <el-tag size="mini" title="点击查看" v-if="scope.row.devcnt" @click="toDevDetail(scope.row)" type="pramary">
              {{ scope.row.devcnt }}次
            </el-tag>
            <el-tag size="mini" v-if="scope.row.lastDrecrtm" @click="toDevDetail(scope.row)" type="danger">
              {{ scope.row.lastDrecrtm }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="300px">
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button size="mini" @click="toShow(scope.$index, scope.row)">详情</el-button>
              <el-button size="mini" type="success" @click="toUpdate(scope.$index, scope.row)"
                v-if="isShow(scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" v-if="isShow(scope.row)"
                @click="remove(scope.$index, scope.row)">删除</el-button>
              <el-dropdown @command="handleCommandOperate">
                <el-button size="mini" v-if="!(scope.row.states == '已关闭')">
                  操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>

                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="scope.row.states == '未开始' ||
                    scope.row.states == '已挂起'
                  " command="开始" :data="scope.row" tabindex>开始</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.states == '进行中'" command="挂起" :data="scope.row"
                    tabindex>挂起</el-dropdown-item>
                  <el-dropdown-item v-if="!(scope.row.states == '已完成') &&
                    !(scope.row.states == '已关闭')
                  " command="关闭" :data="scope.row" tabindex>关闭</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.states == '未开始' ||
                    scope.row.states == '进行中'
                  " command="转让" :data="scope.row" tabindex>转让</el-dropdown-item>
                  <el-dropdown-item command="任务分解" :data="scope.row" tabindex v-if="(scope.row.level < 2) &
                    (scope.row.states == '未开始' ||
                      scope.row.states == '进行中')
                  ">任务分解</el-dropdown-item>

                  <el-dropdown-item v-if="(!scope.row.childNode || scope.row.pid) &&
                    !(scope.row.states == '未开始') &&
                    !(scope.row.states == '已挂起') && (scope.row.tmName === me.name)
                  " command="开发日志" :data="scope.row">开发日志</el-dropdown-item>

                  <el-dropdown-item v-if="!(scope.row.states == '未开始')" command="审视" :data="scope.row"
                    tabindex>审视</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 任务分解 -->
      <el-drawer title="任务分解" size="50%" :wrapperClosable="false" :visible.sync="dialog" :before-close="handleClose"
        custom-class="demo-drawer" ref="drawer">
        <div class="demo-drawer__content">
          <el-form :model="form" label-width="80px" :disabled="disabled">
            <el-row>
              <el-col :span="12">
                <el-form-item label="代办名称">
                  <el-input autocomplete="off" v-model="form.name"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="产品代办">
                  <el-input autocomplete="off" disabled v-model="problogName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="团队成员" clearable prop="teamMember"><el-input v-model="teamMember" :readonly="true"
                    autocomplete="off"></el-input></el-form-item>
              </el-col>
              <el-col :span="3">
                <el-button type="primary" @click="openTMember()">请选择</el-button>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="执行状态">
                  <select-option-dictionary dkey="spr-backlog-states" v-model="form.states"></select-option-dictionary>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预计工时">
                  <el-input autocomplete="off" placeholder="单位小时" v-model="form.hopegs"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="计划开始" v-model="form.pbgntm">
                  <el-date-picker v-model="form.pbgntm" value-format="yyyy-MM-dd" type="date"
                    placeholder="选择计划开始时间"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="计划完成" v-model="form.pendtm">
                  <el-date-picker v-model="form.pendtm" value-format="yyyy-MM-dd" type="date"
                    placeholder="选择计划开始时间"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="目标" v-model="form.pgoal">
                  <el-input :rows="6" v-model="form.pgoal" autocomplete="off" type="textarea"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="备注" v-model="form.remark">
                  <el-input :rows="3" v-model="form.remark" autocomplete="off" type="textarea"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="demo-drawer__footer">
          <el-button type="primary" :loading="loading" @click="taskBreak()">确 定</el-button>
          <el-button @click="cancelForm()">取 消</el-button>
        </div>
      </el-drawer>
      <!-- 任务分解选择部门 -->
      <el-dialog center :visible.sync="innerVisible" :modal="false" :before-close="outClose">
        <el-table class="table" height="auto" :data="teamMembers" @selection-change="selChgTeamMember">
          <el-table-column type="selection" width="55" fixed="left"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="post" label="角色"></el-table-column>
          <el-table-column prop="dept" label="部门"></el-table-column>
        </el-table>
        <span slot="footer">
          <el-button type="primary" @click="confirmTeamMember">确认</el-button>
          <el-button @click="innerVisible = false">取消</el-button>
        </span>
      </el-dialog>
      <!-- 转让 -->
      <el-drawer title="转让" size="50%" :visible.sync="zrdialog" :wrapperClosable="false" :before-close="handleClose">
        <el-table class="table" height="400" :data="teamMembers" @selection-change="zrSelChgTeamMember">
          <el-table-column type="selection" width="55" fixed="left"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="post" label="角色"></el-table-column>
          <el-table-column prop="dept" label="部门"></el-table-column>
        </el-table>
        <br />
        <span>
          <el-button type="primary" @click="confirmZrMember">确认</el-button>
          <el-button @click="zrdialog = false">取消</el-button>
        </span>
      </el-drawer>

      <!-- 编辑 -->
      <el-dialog title="审视记录" class="el-dialog__body" v-model="EditorParameter" :visible.sync="revealedit" width="50%"
        :modal="false" center>
        <el-form class="dataForm" ref="form" :inline="true" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="审视人" clearable>
                <el-input v-model="EditorParameter.dbColumn_user_id" disabled>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="处理情况" clearable prop="killbug">
                <el-input v-model="EditorParameter.killbug" disabled>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="bug数量" clearable prop="bugcnt">
                <el-input v-model="EditorParameter.bugcnt"> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="审视结论" clearable prop="conclusion">
                <wang-edit :isupdt="isUpdtWedit" v-model="EditorParameter.conclusion">
                </wang-edit>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="revealedit = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
    <edit ref="edit" :selectProd="selectProd" :sprintId="sprintId"></edit>
    <editDevRecord ref="editDevRecord"></editDevRecord>
    <editSurvey ref="editSurvey"></editSurvey>
    <editSurveyRecord ref="editSurveyRecord"></editSurveyRecord>
    <showDevRecord ref="showDevRecord"></showDevRecord>
  </div>
</template>
<script>
import edit from "./edit.vue";
import api from "@/api/sprint/sprintBacklog/sprintBacklog.js";
import apiProductBoard from "@/api/product/productBoard/productBoard.js";

import productApi from "@/api/product/product/product.js";

import apiDevRecord from "@/api/sprint/devRecord/devRecord.js";
import editDevRecord from "@/views/sprint/dev_record/edit.vue";
import showDevRecord from "@/views/sprint/dev_record/show.vue";
import apiSur from "@/api/sprint/survey_record/survey_record.js";
import editSurvey from "@/views/sprint/survey/edit.vue";
import editSurveyRecord from "@/views/sprint/survey_record/edit.vue";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import wangEdit from "@/components/wangEdit/wangEdit.vue";
import apiTeamMember from "@/api/team/teamMember/teamMember.js";

export default {
  name: "sprintBacklog",
  components: {
    edit,
    editDevRecord,
    editSurvey,
    selectOptionDictionary,
    editSurveyRecord,
    showDevRecord,
    wangEdit,
  },
  data() {
    return {
      searchParams: {},
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      productList: [], //装载产品的数据
      dialog: false,
      form: {}, //提交任务分解的数据
      allPlaned: 0, //现有SprintBL已分配工时
      loading: false,
      isUpdtWedit: false, //用于更新wangEdit
      disabled: false, //控制任务分解的抽屉
      confirmLoading: false,
      selectProd: undefined, //选中的产品id
      curSprint: undefined, //产品待办
      selectTeam: "", //选中的团队
      problogName: "", //产品代办名称
      innerVisible: false, //控制任务分解时选择团队成员的弹框
      teamMember: "", //选中的团队成员名称
      teamMembers: [],
      sleTeamMember: [], //分解时选中的团队成员
      zrSleTeamMember: [], //转让时选中的团队成员
      zrdialog: false, //控制转让抽屉答代开

      teamAndMember: [], //查询出来的团队和成员

      revealedit: false, //显示审视记录页面
      EditorParameter: {}, //审视记录

      tName: "", //团队的名称
      rowId: "", //转让时拿到该条数据id
      zrObj: {}, //转让传给后端的对象
      sprintId: "",
      sprintListData: [],
      pids: [], //父pid列表
      me: {},
      availableWH: 0, //可用工时
      alreadyArrangedWH: 0, //已布置工时
      completeWH: 0, //已完成工时

    };
  },
  methods: {
    showSur(surid) {
      apiSur.toUpdate({ id: surid }, (res) => {
        this.EditorParameter = res.data;
        this.isUpdtWedit = true;
        setTimeout(() => {
          this.isUpdtWedit = false;
        }, 100);
        this.revealedit = true;
      });
    },
    //去详情
    toDevDetail(row) {
      let kfAdvance = row.wchours
        ? ((100 * row.realgs) / row.wchours).toFixed(0)
        : 0;
      let param = {
        id: row.id,
        sbiId: row.id,
        sprName: row.name,
        kfAdvance: kfAdvance,
        wchours: row.wchours,
        hopegs: row.hopegs,
      };
      this.$refs.showDevRecord.open(param, row.name + " - 开发日志", this.me);
    },

    isShow(row) {
      if ("ad" == this.me.role) {
        return true;
      }

      if (row.states == "未开始" || row.states == "已关闭") {
        if (row.crer == this.me.id || this.me.name == row.tmName) {
          return true;
        }
      }

      return false;
    },

    //页面初始化,获取产品数据，从浏览器获取存储的产品和sprint数据， 主要是初始化顶部搜索框条件
    init() {
      this.productList = this.$caches.products.get();
      if (!this.productList) {
        //获取产品数据并存入productData
        productApi.list4Select({}, (response) => {
          this.productList = response.data;
          this.$caches.products.set(this.productList);
        });
      }

      //初始化搜索框内容
      if (!this.selectProd) {
        //如果没有选中过产品就到浏览器查看是否存有选过的产品数据，没有就不进行操作（第一次打开页面）
        //const proId = localStorage.getItem("pid");
        const proId = this.$caches.pid.get();
        if (proId) {
          //浏览器存有id则设置产品的id
          this.searchParams.proId = proId;
          this.selectProd = proId;
          //	console.log("浏览器存的产品id", proId);
          //查询该产品的sprint数据并存入	sprintListData
          api.getSBLByProId({ proId: this.searchParams.proId }, (response) => {
            this.sprintListData = response.data;

            //查看浏览器是否存有sprintid
            //console.log("初始化到这里!!!!!!!");
            const sprid = localStorage.getItem("sprintId");
            //console.log("浏览器sprid",sprid);
            if (sprid) {
              //如果有产品id则设置选择框的sprint
              // TODO 是否要校验这个从浏览器获取的sprintID是不是 属于浏览器存的产品的sprint
              this.sprintId = sprid;
              this.curSprint = this.sprintListData.filter(v => v.id == this.sprintId)[0];
              this.searchParams.sprintId = sprid;
              //产品与sprint设置完毕则调用list
              this.list();
            } else {
              //console.log("初始化没有sprintID!!!!!!!");
              //如果浏览器没有sprintID则默认选中产品的第一个sprint  并存入浏览器
              this.sprintId = this.sprintListData[0].id;
              this.searchParams.sprintId = this.sprintListData[0].id;
              //this.$caches.sprintId.set(this.sprintListData[0].id)
              localStorage.setItem("sprintId", this.sprintListData[0].id);
              //产品与sprint设置完毕则调用list
              this.list();
            }

            console.log("this.teamMembers", this.teamMembers)

            //加载队员
            //if (!this.teamMembers || this.teamMembers.length == 0) {
            apiTeamMember.getTMemberBySprId(false, (response) => {
              if (response.data) {
                this.teamMembers = response.data;
                this.$caches.teammembes.set(this.teamMembers);
              }
            });
            //}
          });
        } else {
          //第一次操作默认没有pid，也就是默认产品和sprint没有默认选择显示。
          //浏览器没有产品id则不进行操作
          console.log("proId === ", proId);
          let params = [];
          let pid = "";
          //请求获取pid列表
          apiProductBoard.productList(params, (response) => {
            params = response.data;
            for (let idx = 0; idx < params.length; idx++) {
              this.pids.push({
                value: params[idx].id,
                label: params[idx].name,
              });
            }

            //默认第一个
            if (this.pids[0]) {
              pid = this.pids[0].value;
            }

            this.$caches.pid.set(pid);
            this.init();
          });
        }
      }
    },

    //获取数据
    list() {
      let params = this.$utils.merger(this.searchParams);
      this.selectTeam = "";
      this.allPlaned = 0
      api.list(params, (response) => {
        this.listData = response.data.list;

        this.availableWH = response.data.availableWH;
        this.alreadyArrangedWH = response.data.alreadyArrangedWH;
        this.completeWH = response.data.completeWH;

        if (this.listData && this.listData.length > 0) {
          this.selectTeam = this.listData[0].tName;
        }


        //计算计划总工时
        this.listData.forEach(v => {
          this.allPlaned += v.hopegs * 1
        })

        this.listLoading = false;
      });
    },
    //去添加
    toSave() {
      let params = {};
      let SprintName = "";
      let ProName = "";
      for (let i = 0; i < this.sprintListData.length; i++) {
        if (this.sprintListData[i].id == this.sprintId) {
          params.startTime = this.sprintListData[i].startTime;
          params.endTime = this.sprintListData[i].endTime;
          SprintName = this.sprintListData[i].name;
        }
      }
      for (let j = 0; j < this.productList.length; j++) {
        if (this.productList[j].id == this.selectProd) {
          ProName = this.productList[j].name;
        }
      }

      //加载队员
      //if (!this.teamMembers || this.teamMembers.length == 0) {
      apiTeamMember.getTMemberBySprId(false, (response) => {
        if (response.data) {
          this.teamMembers = response.data;
          this.$caches.teammembes.set(this.teamMembers);
          params.teamAndMember = this.teamMembers;
          params.sprid = this.sprintId;

          //剩余可派工时
          if (this.allPlaned && this.curSprint && this.curSprint.allManDay !== undefined) {
            params.hasArriHopegs = this.curSprint.allManDay * 8 - this.allPlaned
          }

          // this.$refs.edit.open(
          //   params,
          //   "添加执行待办: " + SprintName + " @ " + ProName,
          //   true
          // );
          this.$refs.edit.open(params, "添加执行待办: " + SprintName + " @ " + ProName, true);
        }
      });

    },
    //去编辑
    toShow(index, row) {
      let editParameter = {
        id: row.id,
        hasChildren: row.childNode ? true : false,
        teamAndMember: this.teamMembers
        
      };

      this.$refs.edit.open(editParameter, "详情", false);
    },
    //去编辑
    toUpdate(index, row) {
      let editParameter = {
        id: row.id,
        hasChildren: row.childNode ? true : false,
        teamAndMember: this.teamMembers,
        sprid: this.sprintId,
      };

      //剩余可派工时
      if (this.allPlaned && this.curSprint && this.curSprint.allManDay !== undefined) {
        editParameter.hasArriHopegs = this.curSprint.allManDay * 8 - this.allPlaned
      }

       this.$refs.edit.open(editParameter, "编辑", true);
    },

    //删除
    remove(index, row) {
      let parameter = {
        id: row.id,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //产品改变
    chgPro(val) {
      //前端存储产品id
      this.$caches.pid.set(val);
      let proId = val;
      this.selectProd = val;
      this.searchParams.proId = val;
      //改变产品 查询该产品下的sprint数据
      api.getSBLByProId({ proId }, (response) => {
        this.sprintListData = response.data;
        this.curSprint = this.sprintListData.filter(v => v.id == this.sprintId)[0];
        if (response.data.length !== 0) {
          //默认选中第一个sprintid
          this.searchParams.sprintId = this.sprintListData[0].id;
          this.sprintId = this.sprintListData[0].id;
          //向浏览器存入sprintId
          //this.$caches.sprintId.set(this.sprintListData[0].id);
          localStorage.setItem("sprintId", this.sprintListData[0].id);
          this.list();
          //加载队员
          apiTeamMember.getTMemberBySprId(false, (response) => {
            if (response.data) {
              this.teamMembers = response.data;
              this.$caches.teammembes.set(this.teamMembers);
            }
          });
        } else {
          this.list();

          //如果该产品没有sprint则移除之前所有存过的sprintid
          localStorage.removeItem("sprintId");
          this.searchParams.sprintId = "";
          this.sprintId = "";
        }
      });
    },
    //sprint改变
    chgSprint(val) {
      //设置搜索框
      this.sprintId = val;
     // console.log(" this.sprintListData >>>>>>>>>>>>>", this.sprintListData);
      this.curSprint = this.sprintListData.filter(v => v.id == this.sprintId)[0];
     // console.log(" this.curSprint >>>>>>>>>>>>>>>>", this.curSprint);

      //将改变的sprintID存入浏览器
      //this.$caches.sprintId.set(val);
      localStorage.setItem("sprintId", val);

      //加载队员
      apiTeamMember.getTMemberBySprId(false, (response) => {
        if (response.data) {
          this.teamMembers = response.data;
          this.$caches.teammembes.set(this.teamMembers);
        }
      });

      this.list();
    },
    //转让时团队选择改变
    chgT(val) {
      let tid = val;
      api.teamAndMember({ tid }, (response) => {
        this.teamAndMember = [];
        response.data.forEach((item) => {
          this.teamAndMember.push(item);
        });
        this.list();
      });
    },
    //开始代办
    startSprintBackLog(row) {
      this.$utils.confirm.warning("提示", "确定开始吗？", () => {
        api.start(row, (response) => {
          this.$utils.msg.success(response.msg);
          this.list();
        });
      });
    },

    //操作
    handleCommandOperate(command, tabindex) {
      //console.log("command",command);
      //console.log("tabindex",tabindex);
      //console.log("row",row);

      if (tabindex.command === "开发日志") {
  let sblId = tabindex.$attrs.data.id;
  let sblogrow = tabindex.$attrs.data;   // ← 待办行，有累计值 wchours / realgs

    console.log('=== 打开开发日志 ===');
  console.log('待办行 sblogrow:', JSON.stringify({
    id: sblogrow.id,
    wchours: sblogrow.wchours,
    realgs: sblogrow.realgs,
    hopegs: sblogrow.hopegs,
  }));



  apiDevRecord.getSprBLId({ sblId }, (response) => {
    if (response.data) {
      let devRecordObj = response.data;
      devRecordObj.pmid = sblogrow.pmid;
      // ↓ 用待办的累计值作为基数，覆盖日志返回的值
      devRecordObj.wchours = sblogrow.wchours || 0;
      devRecordObj.realgs = sblogrow.realgs || 0;

            console.log('覆盖后传给 edit:', JSON.stringify({
        wchours: devRecordObj.wchours,
        realgs: devRecordObj.realgs,
      }));

      delete devRecordObj.id;
      this.$refs.editDevRecord.open(sblogrow, devRecordObj, "添加开发日志1 - " + sblogrow.tmName);
    } else {
      // ↓ 没有历史日志时也要带累计值
      let newObj = {
        pmid: sblogrow.pmid,
        wchours: sblogrow.wchours || 0,
        realgs: sblogrow.realgs || 0,
      };
      this.$refs.editDevRecord.open(sblogrow, newObj, "添加开发日志2 - " + sblogrow.tmName);
    }
  });
} else if (tabindex.command === "审视") {



        this.$refs.editSurveyRecord.open(
          {
            sprintbacklogId: tabindex.$attrs.data.id,
            sprId: tabindex.$attrs.data.sprid,
            pgoal: tabindex.$attrs.data.pgoal,
          },
          "对待办进行审视-增加审视记录"
        );
      } else if (
        tabindex.command === "开始" ||
        tabindex.command === "挂起" ||
        tabindex.command === "关闭"
      ) {
        this.$utils.confirm.warning(
          "提示",
          "确定" + tabindex.command + "吗？",
          () => {
            let parameter = {
              id: tabindex.$attrs.data.id,
              states:
                tabindex.command == "开始" ? "进行中" : "已" + tabindex.command,
            };
            api.update(
              parameter,
              (response) => {
                this.$utils.msg.success(response.msg);
                this.confirmLoading = false;
                this.list();
              },
              (response) => {
                this.$utils.msg.warning(response.msg);
                this.confirmLoading = false;
              }
            );
          }
        );
      } else if (tabindex.command === "任务分解") {
        let msg = "";

        if (tabindex.$attrs.data.hopegsOrg - tabindex.$attrs.data.hopegs < 0) {
          msg =
            "目前已分配" +
            tabindex.$attrs.data.hopegs +
            "(h) 已超过可分配工时: " +
            tabindex.$attrs.data.hopegsOrg +
            "(h)";
        } else {
          msg = "任务总工时为： " +
            tabindex.$attrs.data.hopegsOrg +
            "(h), 目前还可以拆分工时为:" +
            (tabindex.$attrs.data.hopegsOrg - tabindex.$attrs.data.hopegs) +
            "(h)"

        }

        this.$utils.confirm.warning("提示", msg, () => {
          this.dialog = true;
          this.form = {
            states: "未开始",
            pbgntm: new Date(),
            pid: tabindex.$attrs.data.id,
            sprid: tabindex.$attrs.data.sprid,
            problogid: tabindex.$attrs.data.problogid,
            pmid: tabindex.$attrs.data.pmid,
          };
          this.problogName = tabindex.$attrs.data.problogName;
          this.teamMember = tabindex.$attrs.data.tmName;
        });
      } else if (tabindex.command === "转让") {
        this.zrSleTeamMember = [];
        this.zrdialog = true;
        this.rowId = tabindex.$attrs.data.id;
        this.tName = tabindex.$attrs.data.tName;
      }
    },
    //分解任务
    taskBreak() {
      api.isSuperWorkingHours(
        this.form,
        (res) => {
          api.save(
            this.form,
            (response) => {
              this.$utils.msg.success(response.msg);
              console.log(response.msg);
              this.confirmLoading = false;
              this.dialog = false;
              this.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        },
        (error) => {
          this.$utils.msg.warning(error.msg);
          api.save(this.form, (response) => {

            // this.$utils.msg.success(response.msg);
            this.confirmLoading = false;
            this.dialog = false;
            this.list();
          }, (response) => {
            console.log(response.msg);
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }),
            // this.$utils.msg.warning(error.msg);
            this.confirmLoading = false;
        }
      );
      //this.dialog = false;
    },
    //关闭弹框
    handleClose(done) {
      done();
    },
    //取消
    cancelForm(val) {
      this.dialog = false;
    },
    //任务分解时打开选择团队列表
    openTMember() {
      this.innerVisible = true;
    },
    //分解时确认团队成员
    confirmTeamMember() {
      this.innerVisible = false;
      if (this.sleTeamMember.length === 0) {
        this.formParameter.pmid = "";
        this.teamMemberName = "";
      } else {
        this.sleTeamMember.forEach((item) => {
          this.form.pmid = item.id;
          this.teamMember = item.name;
        });
      }
    },
    //确定转让-团队成员
    confirmZrMember() {
      let tmId = this.zrSleTeamMember[0].id;
      this.zrObj = { id: this.rowId, tmId: tmId };
      api.zhuanRang(
        this.zrObj,
        (response) => {
          this.$utils.msg.success(response.msg);
          this.confirmLoading = false;
          this.list();
        },
        (response) => {
          this.$utils.msg.warning(response.msg);
          this.confirmLoading = false;
        }
      );
      this.zrdialog = false;
    },
    //分解任务时选择中团队成员
    selChgTeamMember(val) {
      this.sleTeamMember = [];
      for (let item of val) {
        this.sleTeamMember.push(item);
      }
    },
    //转让时选择团队成员
    zrSelChgTeamMember(val) {
      this.zrSleTeamMember = [];
      for (let item of val) {
        this.zrSleTeamMember.push(item);
      }
    },
    //关闭选择成员弹出框
    outClose(done) {
      done();
    },
    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      for (let item of val) {
        this.selected.push(item.id);
      }
    },

    //搜索
    search() {
      this.list();
    },
    //清空搜索框
    clearSearchVal() {
      this.searchParams = {};
    },
    handleExeed() {
    }




  },
  mounted() {
    this.init();
    this.me = this.$caches.user.get();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
</style>
